

export const footerReducer = (state=[], action) => {
    return state;
}